import React from "react";
import { Grid, Paper, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ScienceIcon from "@mui/icons-material/Science";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import RadiologyIcon from "@mui/icons-material/MedicalInformation";
import BiotechIcon from "@mui/icons-material/Biotech";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import { useTheme } from "@mui/material/styles";

const ReportsIndex = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const cards = [
    {
      title: t("reports.financeReport"),
      description: t("reports.financeReportDescription"),
      path: "/finance/report",
      icon: <AccountBalanceIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.receptionRevenueReport"),
      description: t("reports.receptionRevenueDescription"),
      path: "/reports/reception-revenue",
      icon: <ReceiptLongIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.doctorActivityReport"),
      description: t("reports.doctorActivityDescription"),
      path: "/reports/doctor-activity",
      icon: <AssignmentIndIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.labOverallReport"),
      description: t("reports.labOverallDescription"),
      path: "/reports/lab-overall",
      icon: <ScienceIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.pharmacyReport"),
      description: t("reports.pharmacyReportDescription"),
      path: "/reports/pharmacy",
      icon: <LocalPharmacyIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.radiologyReport"),
      description: t("reports.radiologyReportDescription"),
      path: "/reports/radiology",
      icon: <RadiologyIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.laboratoryReport"),
      description: t("reports.laboratoryReportDescription"),
      path: "/reports/laboratory",
      icon: <BiotechIcon sx={{ fontSize: 48 }} />,
    },
    {
      title: t("reports.surgeryReport"),
      description: t("reports.surgeryReportDescription"),
      path: "/reports/surgery",
      icon: <MedicalServicesIcon sx={{ fontSize: 48 }} />,
    },
  ];

  return (
    <Grid container maxWidth="xl" spacing={3} sx={{ p: 3, width: "100%" }}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} key={card.path}>
          <Paper
            elevation={2}
            sx={{
              p: 3,
              cursor: "pointer",
              height: "100%",
              transition: "box-shadow 0.3s, transform 0.2s",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-4px)",
              },
              borderLeft: `4px solid ${theme.palette.primary.main}`,
            }}
            onClick={() => navigate(card.path)}
          >
            <Box sx={{ color: "primary.main", mb: 2 }}>{card.icon}</Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              {card.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {card.description}
            </Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default ReportsIndex;
